import _ from 'lodash';
import * as types from '../mutation-types';
import config from '@/config';
import { loadDataForSnapshot } from '@/utils/loading';
import { SERVICE_TYPES } from '@/utils/variables';
import Vue from 'vue';


const state = {
  services: {},
};

const mutations = {
  [types.SET_SERVICES]: (state, services) => {
    const newServices = {};
    const defaults = {
      selected: false,
    };
    Object.keys(services).forEach((serviceId) => {
      const service = services[serviceId];
      newServices[serviceId] = {
        ...service,
        ...defaults,
      };
    });
    state.services = newServices;
  },
  [types.UPDATE_SERVICES]: (state, { services }) => {
    services.forEach((service) => {
      const oldService = state.services[service.id];
      if (oldService) {
        state.services[service.id] = { ...oldService, ...service };
      }
    });
  },
  [types.TOGGLE_SERVICE_SELECTED]: (state, service) => {
    service.selected = !service.selected;
  },
  [types.SET_FAVORITE_SERVICE]: (state, { service, favorite }) => {
    service.favorite = favorite;
  },
};

const getters = {
  getServices: state => Object.values(state.services),
  getDevices: (state, getters) => getters.getServices.filter(
    service => service.type === SERVICE_TYPES.DEVICE,
  ),
  getServiceById: state => id => state.services[id],
  getServicesByIds: state => ids => ids.map(id => state.services[id]),
  getServicesByPlaceAndGroup: (state, getters) => (place, serviceGroup) => (
    getters.getServices.filter(
      service => (
        _.includes(service.places, place.id)
        && _.includes(service.serviceGroups, serviceGroup.id)
        && service.type === 'virtual_device'
      ),
    )
  ),
  getServiceName: (state, getters, rootState, rootGetters) => (serviceId) => {
    const service = getters.getServiceById(serviceId);
    return rootGetters['user/isUserInstaller'] ? service.name : service.user_name || service.name;
  },
  getFavoriteServices: (state, getters) => getters.getServices.filter(
    service => service.favorite,
  ),
  getErrorServices: (state, getters, rootState, rootGetters) => getters.getServicesByIds(
    rootGetters.getErrorStatusActors.filter(
      actor => rootGetters.getVarById(actor.singleVarId)?.value,
    ).map(actor => actor.serviceId),
  ),
  hasServiceError: (state, getters, rootState, rootGetters) => (serviceId) => {
    const errorActor = rootGetters.getServiceErrorStatusActor(serviceId);
    if (errorActor) {
      return rootGetters.getVarById(errorActor.singleVarId).value;
    }
    return false;
  },
};

const actions = {
  async loadServices({ commit, rootState }) {
    return loadDataForSnapshot(
      commit, rootState, types.SET_SERVICES, config.ICOOL.API.SERVICES_PATH,
    );
  },
  updateServices({ commit, dispatch }, { services }) {
    commit(types.UPDATE_SERVICES, { services });
  },
  toggleServiceSelection({ commit }, service) {
    commit(types.TOGGLE_SERVICE_SELECTED, service);
  },
  setFavoriteService({ commit }, { service, favorite }) {
    commit(types.SET_FAVORITE_SERVICE, { service, favorite });
  },
  SOCKET_SERVICE_UPDATED({ commit, getters }, msg) {
    const data = JSON.parse(msg);
    Vue.$log.debug(data);
    commit(types.UPDATE_SERVICES, { services: [data] });
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
